export const IntegrationMoreInfo = {
  OverviewLink: 'https://docs.sequencehq.com/connectors/overview',
  AccountingOverviewLink:
    'https://docs.sequencehq.com/connectors/accounting-overview',
  XeroLink: 'https://docs.sequencehq.com/connectors/xero',
  StripeLink: 'https://docs.sequencehq.com/connectors/stripe',
  QuickbooksLink: 'https://docs.sequencehq.com/connectors/quickbooks',
  NetsuiteLink: 'https://docs.sequencehq.com/connectors/netsuite',
  GoogleSheetsLink: 'https://docs.sequencehq.com/data/exporting-data',
  BigQueryLink: 'https://docs.sequencehq.com/connectors/bigquery',
  SnowflakeLink: 'https://docs.sequencehq.com/connectors/snowflake',
  RedshiftLink: 'https://docs.sequencehq.com/connectors/redshift',
  HubSpotLink: 'https://docs.sequencehq.com/connectors/hubspot#hubspot',
  HubSpotSyncingCustomersLink:
    'https://docs.sequencehq.com/connectors/hubspot#syncing-customers'
}
